<template>
	<div class="creditcard-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					<strong>{{
						$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_01.title.one')
					}}</strong>
					{{
						$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_01.title.two')
					}}
				</h2>
				<p>
					{{
						$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_01.desc.one')
					}}<br />
					{{
						$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_01.desc.two')
					}}
					<br />
					{{
						$t(
							'new_ui.personal_jpworldpay_creditcard_page_v2.sec_01.desc.three',
						)
					}}
				</p>
			</div>
		</section>
		<section class="sec-08">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.title') }}
				</h3>
				<div>
					<p>
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.one.desc.one',
							)
						}}<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.one.desc.two',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.one.desc.three',
							)
						}}
					</p>
					<a href="#" @click="showComingSoon" class="btn-type-01">
						{{
							$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.one.btn')
						}}
					</a>
				</div>
				<div class="txt-box">
					<p>
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.desc.one',
							)
						}}<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.desc.two',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.desc.three',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.desc.four',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.desc.five',
							)
						}}
					</p>
					<a href="/terms/terms/franchise_agreement" class="btn-type-01">
						{{
							$t('new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.btn')
						}}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							<strong>{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.title.one',
								)
							}}</strong
							><br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.title.two',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.title.three',
								)
							}}
						</h3>
						<p>
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.desc.one',
								)
							}}<br />{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.desc.two',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.desc.three',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.desc.four',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.one.desc.five',
								)
							}}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgCreditcardSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgCreditcardSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.title.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.title.two',
								)
							}}
						</h3>
						<p>
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.desc.one',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.desc.two',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_03.two.desc.three',
								)
							}}
						</p>
						<a href="#" @click="showComingSoon" class="btn-type-02">
							{{
								$t(
									'new_ui.personal_jpworldpay_creditcard_page_v2.sec_08.two.btn',
								)
							}}
						</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgCreditcardSec0301 from '@/assets/images/v2/img-creditcard-sec-03-01.png';
import imgCreditcardSec0302 from '@/assets/images/v2/img-creditcard-sec-03-02.png';

export default {
	data: () => {
		return {
			img: {
				imgCreditcardSec0301,
				imgCreditcardSec0302,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert(
				this.$t(
					'new_ui.personal_jpworldpay_creditcard_page_v2.common.coming_soon',
				),
			);
		},
	},
};
</script>
